import {
  Button,
  Modal,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React from "react";
import "./LoginAlerts.css";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const LoginAlert = ({ loginPopoverVisible, setLoginPopoverVisible }) => {
  const navigate = useNavigate();

  const accessToLoginToAccessCampaign = () => {
    navigate("/login");
  };
  return (
    <div className="create-new-campaign-popover">
      <Modal
        rootClassName="login-alert-modal"
        open={loginPopoverVisible}
        className="login-to-access-campaign-popover"
        footer={null}
        closable={true}
        maskClosable={true}
        centered
        width="42.0625rem"
        height="17.9375rem"
        onCancel={() => setLoginPopoverVisible(false)}
      >
        <div className="login-to-access-campaign-popover-div">
          <Text className="login-to-access-campaign-popover-tittle">
            Login to Create Your Campaigns
          </Text>
          <div className="login-to-access-campaign-popover-text-div">
            <Text className="login-to-access-campaign-popover-text">
              Please login to view or select your campaigns. Don't have an
              account? Sign up now to get started!
            </Text>
          </div>
          <div className="login-to-access-campaign-popover-lgn-btn-div">
            <Button
              className="login-to-access-campaign-popover-lgn-btn"
              onClick={accessToLoginToAccessCampaign}
            >
              Login
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default LoginAlert;
